
import { useCallback, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { categoriasSeccionCompras, categoriaXID, listadoCategoriasSelect, listadoTodosCategorias } from "../../../services";





export const useCategoriaXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['categoriaxid', id], 
        queryFn: () => categoriaXID(id),
        enabled: !!id,
    });
    return { data, isLoading }
}




export const useCategoriaSeccionCompras = () => {
    const [termino, setTermino] = useState('');
    const chageTermino = useCallback((valor) => {
        setTermino(valor)
    }, [])


    const { data, isLoading } = useQuery({
        queryKey: ['categoria-seccioncompra', termino], 
        queryFn: () => categoriasSeccionCompras(termino),
    });
    
    return {
        // Estados
        termino,
        // Metodos
        chageTermino,
        data, isLoading,
    }
}





export const useTodosCategorias = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['categorias-todos', { page, termino }], 
        queryFn: () => listadoTodosCategorias({ page, termino }),
    });

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}





export const useCategoriaSelect = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['categoria-select'], 
        queryFn: () => listadoCategoriasSelect(),
    });

    return { data, isLoading }
}











